import { render } from "./TemplateTicketCard.vue?vue&type=template&id=6282293c&scoped=true"
import script from "./TemplateTicketCard.vue?vue&type=script&lang=js"
export * from "./TemplateTicketCard.vue?vue&type=script&lang=js"

import "./TemplateTicketCard.vue?vue&type=style&index=0&id=6282293c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6282293c"]])

export default __exports__